<template>
  <div :class="votingCheckClasses">
    <FlexWrap>
      <div class="container">
        <header class="title-wrapper">
          <transition name="title" mode="out-in">
            <p v-if="panel === 'begin'" class="title">Even kijken of jij daarbij hoorde.<br>
            <span class="large">Voldoe je aan een van onderstaande kenmerken?</span></p>
            <h2 v-if="panel === 'age'" class="large">
              Waarschijnlijk had jij in 1896 mogen stemmen, gefeliciteerd. Tenminste… één dingetje nog:
            </h2>
            <h2 v-if="panel === 'success'">
              Oké, dan staat echt niks meer jouw tripje naar de stembus in de weg. De kiesgerechtigde leeftijd ging in 1896 omhoog naar 25 jaar.
            </h2>
            <h2 v-if="panel === 'fail'">
              {{ failText }}
            </h2>
          </transition>
        </header>
        <figure class="figure">
          <img
            :src="src"
            draggable="false"
            alt=""
            class="character"
            width="50"
            height="164"
            :class="characterClasses"
          />
        </figure>
        <transition name="title" mode="out-in">
          <div v-if="panel === 'begin'">
            <ul class="check-list">
              <li
                class="item"
                v-for="(item, index) in items"
                :key="index"
              >
                <component class="icon" :is="item.icon" />
                <label class="label">
                  <span class="text">{{ item.text }}</span>
                  <input
                    type="checkbox"
                    class="checkbox"
                    :value="index"
                    v-model="checkedItems"
                    :name="`check-list-item-${index}`"
                  />
                  <span class="box">
                    <svg class="vink" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 17 13.31"><path d="M4.17 12.83L.48 9.13a1.64 1.64 0 0 1 0-2.32 1.64 1.64 0 0 1 2.32 0l2.53 2.54L14.2.48a1.64 1.64 0 0 1 2.32 0 1.64 1.64 0 0 1 0 2.32l-10 10a1.64 1.64 0 0 1-2.35.03z" fill="#fff"/></svg>
                  </span>
                </label>
              </li>
            </ul>
          </div>
        </transition>
        <footer class="footer">
          <Button
            v-if="panel === 'begin'"
            @click.native="next"
          >
            check
          </Button>
          <AgeCheck v-if="panel === 'age'" />
          <ScrollChevron
            scrollTo=".chapter-3-panel-2"
            :conditionals="panel === 'fail' || panel === 'success'"
          />
        </footer>
      </div>
    </FlexWrap>
  </div>
</template>

<script>
import VueScrollTo from 'vue-scrollto'
import { EventBus } from '@/EventBus'
import { ScrollChevron, FlexWrap } from '@/components/chapter'
import IconCoin from './IconCoin'
import IconHouse from './IconHouse'
import IconSchool from './IconSchool'
import IconSuitcase from './IconSuitcase'
import Button from '@/components/Button'
import AgeCheck from './AgeCheck'
import { trekInteractive } from '@/utils/trek'

export default {
  name: 'VotingCheck',
  data () {
    return {
      filename: 'fy',
      failText: 'Helaas voldoe je niet aan de voorwaarden om te mogen stemmen. Maar daar had je sowieso geen kans op gemaakt. Nog altijd hadden vrouwen namelijk geen stemrecht. Dat stond zelfs expliciet in de wet.',
      checkedItems: [],
      panel: 'begin',
      items: [{
        icon: IconHouse,
        text: 'Huurwoning'
      }, {
        icon: IconSuitcase,
        text: 'Maandelijks vast salaris'
      }, {
        icon: IconCoin,
        text: 'Spaarrekening'
      }, {
        icon: IconSchool,
        text: 'Gestudeerd'
      }]
    }
  },
  components: {
    IconHouse,
    IconSuitcase,
    IconCoin,
    IconSchool,
    Button,
    AgeCheck,
    ScrollChevron,
    FlexWrap
  },
  mounted () {
    EventBus.$on('isOldEnough', bool => {
      trekInteractive('1896-kenmerken-age-check')
      this.panel = bool ? 'success' : 'fail'
      this.failText = 'Jammer, stemmen zit  er voor jou tóch niet in. De kiesgerechtigde leeftijd ging in 1896 namelijk omhoog naar 25 jaar.'
    })

    EventBus.$on('characterChoice', filename => {
      this.filename = filename
    })
  },
  computed: {
    src () {
      return require(`@/assets/images/char-${this.filename}.svg`)
    },
    characterClasses () {
      return {
        'character': true,
        'age': this.panel === 'age',
        'small': this.panel === 'begin'
      }
    },
    votingCheckClasses () {
      return {
        'voting-check': true,
        'fail-voting-check': this.panel === 'fail'
      }
    }
  },
  methods: {
    next () {
      trekInteractive('1896-kenmerken')
      // scroll to top
      VueScrollTo.scrollTo('.voting-check', 500)

      const enoughChecked = this.checkedItems.length > 0
      EventBus.$emit('votingCheck', enoughChecked)
      this.panel = (this.filename === 'mo' && enoughChecked) ? 'age' : 'fail'

      if (['fy', 'fo'].includes(this.filename)) {
        this.failText = enoughChecked ? 'Je hoopte misschien dat je nu kans zou maken op een stembiljet. Maar helaas voor jou hadden vrouwen nog steeds geen stemrecht. Dat stond zelfs expliciet in de wet, ondanks de opkomst van organisaties die streden voor vrouwenkiesrecht.' : 'Helaas voldoe je niet aan de voorwaarden om te mogen stemmen. Maar daar had je sowieso geen kans op gemaakt. Nog altijd hadden vrouwen namelijk geen stemrecht. Dat stond zelfs expliciet in de wet.'
      }

      if (this.filename === 'my') {
        this.failText = enoughChecked ? 'Je hoopte misschien dat je nu kans zou maken op een stembiljet. Maar helaas ben je nog steeds te jong om te stemmen. Sterker nog: je moet nog een paar jaar extra geduld hebben. De nieuwe kieswet verhoogde de stemgerechtigde leeftijd namelijk van 23 naar 25 jaar.' : 'Helaas voldoe je niet aan de voorwaarden om te mogen stemmen. Maar daar had je sowieso geen kans op gemaakt, want je bent nog steeds te jong. Sterker nog: je moet nog een paar jaar geduld hebben. De nieuwe kieswet verhoogde de stemgerechtigde leeftijd namelijk van 23 naar 25 jaar.'
      }

      if (this.filename === 'mo') {
        this.failText = 'Helaas voldoe je niet aan de voorwaarden om te mogen stemmen.'
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.voting-check {
  background-color: $c-blue;
  color: white;
  transition: background-color 1s ease;
}

.fail-voting-check {
  background-color: $c-red;
}

.title-enter-active,
.title-leave-active {
  transition: all 1600ms cubic-bezier(0.19, 1, 0.22, 1);
  transition-property: opacity, transform;
  will-change: opacity, transform;
}

.title-leave-active {
  transition-duration: 400ms;
}

.title-enter,
.title-leave-to {
  opacity: 0;
}

.title-enter {
  transform: translateY(-25px);
}

.title-leave-to {
  transform: translateY(25px);
}

.title-wrapper {
  // height: 135px;
  text-align: center;
}

.large {
  font-size: 26px;
  font-weight: $fw-bold;
  text-align: center;
}

.figure {
  text-align: center;
  padding: 2em 0;
}

.character {
  transition: transform 2500ms cubic-bezier(0.19, 1, 0.22, 1);
  transform: scale(1.5);
  will-change: transform;
  transform-origin: 50% 0;
}

.small {
  transform: scale(1);
}

.age {
  transform: scale(1.25);
}

.bold {
  font-weight: $fw-bold;
}

.check-list {
  padding: 0;
  text-align: left;
}

.item {
  @extend %clearfix;

  display: block;
  padding-bottom: 20px;
  cursor: pointer;
}

.icon {
  width: 44px;
  height: 44px;
  float: left;
}

.label {
  display: block;
  padding-left: 60px;
  padding-top: 8px;
  width: 100%;
  cursor: pointer;
}

.box {
  display: inline-block;
  width: 24px;
  height: 24px;
  border-radius: 50%;
  background: rgba(#212121, 0.2);
  overflow: hidden;
  float: right;
  cursor: pointer;
  position: relative;
  margin-top: 3px;

  &::after {
    content: '';
    transition: transform .2s ease;
    position: absolute;
    left: 0;
    right: 0;
    bottom: 0;
    top: 0;
    border-radius: 50%;
    background-color: $c-dark;
    transform: scale(0);
  }
}

.footer {
  position: relative;
  height: 135px;
  text-align: center;
}

.vink {
  width: 12px;
  height: auto;
  position: absolute;
  left: 0;
  right: 0;
  top: 50%;
  transform: translateY(-50%);
  margin: 0 auto;
  opacity: 0;
  z-index: 2;
}

.checkbox {
  display: none;
  position: relative;
  z-index: -9999;

  &:checked + .box {
    &::after {
      transform: scale(1);
    }

    .vink {
      opacity: 1;
    }
  }
}
</style>
